export default {
    tableHeaderCellStyle: {
        "background-color": "#f4f8fb",
        "color": "rgba(0, 0, 0, 0.85)"
    }
};
